import React from "react";

function SvgIcMapPoi051(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M21 17l-5 11-5-11h10zM16 5a3.998 3.998 0 013.884 3.058c.2-.037.405-.058.616-.058a3.498 3.498 0 01.5 6.96V15H11v-.04A3.498 3.498 0 0111.5 8c.211 0 .416.021.616.058A3.998 3.998 0 0116 5z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi051;
